var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.82 92.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-2{stroke-width:0.35px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diagram"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.32 68.84 79.32 23.33 39.91 0.58 0.5 23.33 0.5 68.84 39.91 91.59 79.32 68.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.5,
    y1: 23.33,
    x2: 39.91,
    y2: 46.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 79.32,
    y1: 23.33,
    x2: 39.91,
    y2: 46.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.91,
    y1: 91.59,
    x2: 39.91,
    y2: 46.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.32 68.84 79.32 23.33 39.91 0.58 0.5 23.33 0.5 68.84 39.91 91.59 79.32 68.84"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.945ba4b768105fb84cec85e1934a5fcc.svg";
export { ForwardRef as ReactComponent };